import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });
api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("mps_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export const adminApi = axios.create({ baseURL: `${API}/admin` });
adminApi.interceptors.request.use((cfg) => {
  const t = sessionStorage.getItem("mps_admin");
  if (t) cfg.headers["X-Admin-Token"] = t;
  return cfg;
});
adminApi.interceptors.response.use(
  (r) => r,
  (e) => {
    if (e.response?.status === 401 && e.config?.url !== "/login") {
      sessionStorage.removeItem("mps_admin");
      window.dispatchEvent(new Event("mps-admin-logout"));
    }
    return Promise.reject(e);
  }
);

export const adminUrl = (path) => `${API}/admin${path}${path.includes("?") ? "&" : "?"}admin_token=${sessionStorage.getItem("mps_admin") || ""}`;

export const img = (p) => (!p ? "/logo.png" : p.startsWith("http") ? p : `${API}/media/${p}`);

export const money = (v) => `${Number(v || 0).toLocaleString("cs-CZ", { maximumFractionDigits: 2 })} Kč`;

export const fmtSize = (b) => (b > 1048576 ? `${(b / 1048576).toFixed(1)} MB` : `${Math.max(1, Math.round((b || 0) / 1024))} kB`);

export const fmtDate = (s) => (s ? new Date(s).toLocaleDateString("cs-CZ") : "");

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Něco se pokazilo, zkuste to prosím znovu.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d.msg || String(d);
}

export const priceOf = (p) => (p.sale_price ? p.sale_price : p.price);

export const plural = (n, one, few, many) => `${n} ${n === 1 ? one : n >= 2 && n <= 4 ? few : many}`;
